export default __webpack_public_path__ + "static/media/naidi-4-2.c4fa8707.svg";